import {
  chakra,
  type ChakraProps,
  forwardRef,
  useModalStyles,
} from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';

export type DrawerOverlineProps = ChakraProps;

export const DrawerOverline = forwardRef<DrawerOverlineProps, 'div'>(
  ({ className: classNameProp, ...restProps }, ref) => {
    const className = cx('chakra-drawer__overline', classNameProp);

    const { overline: overlineStyles } = useModalStyles();

    return (
      <chakra.div
        ref={ref}
        __css={overlineStyles}
        className={className}
        {...restProps}
      />
    );
  },
);
DrawerOverline.displayName = 'DrawerOverline';
